import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const PHONE = "919080924318";

const WhatsappButton = () => {
  const message = encodeURIComponent(
    `Hi Nirkana, I'd like to know more about planning an event. (Sent from ${window.location.href})`
  );

  return (
    <a
      href={`https://wa.me/${PHONE}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Nirkana on WhatsApp"
      className="fixed bottom-6 left-6 z-30 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition hover:brightness-95"
    >
      <FaWhatsapp size={28} />
    </a>
  );
};

export default WhatsappButton;
